var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6936 38.1H28.7366C34.1363 38.1 38.5296 33.7062 38.5298 28.3062V17.6938C38.5298 12.2936 34.1363 7.9 28.7366 7.9H16.6936C11.2932 7.9 6.9 12.2936 6.9 17.6938V28.3062C6.9 33.7062 11.2934 38.1 16.6936 38.1ZM9.25406 17.6938C9.25406 13.5918 12.5914 10.2545 16.6934 10.2545H28.7364C32.838 10.2545 36.1755 13.5918 36.1755 17.6938V28.3062C36.1755 32.4082 32.838 35.7453 28.7364 35.7453H16.6934C12.5914 35.7453 9.25406 32.4082 9.25406 28.3062V17.6938Z",
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9864 23.0002C13.9864 27.8129 17.9018 31.7287 22.7149 31.7287C27.528 31.7287 31.4436 27.8128 31.4436 23.0002C31.4436 18.1865 27.528 14.2713 22.7149 14.2713C17.9016 14.2713 13.9864 18.1865 13.9864 23.0002ZM16.3407 23.0002C16.3407 19.4851 19.2 16.6254 22.7149 16.6254C26.2297 16.6254 29.0894 19.4851 29.0894 23.0002C29.0894 26.5148 26.2297 29.3745 22.7149 29.3745C19.2002 29.3745 16.3407 26.5148 16.3407 23.0002Z",
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2113 12.7462H31.2112C30.1671 12.7462 29.3209 13.5924 29.3209 14.6369C29.3209 15.6803 30.1669 16.5269 31.2112 16.5269C32.2554 16.5269 33.1016 15.6805 33.1016 14.6369C33.1016 13.5924 32.2554 12.7464 31.2113 12.7462Z",
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.43f1ce1c42c0f12aef7a73b0e97600af.svg";
export { ForwardRef as ReactComponent };